import { render, staticRenderFns } from "./DoseCard.vue?vue&type=template&id=dc0cdc5e"
import script from "./DoseCard.vue?vue&type=script&lang=js"
export * from "./DoseCard.vue?vue&type=script&lang=js"
import style0 from "./DoseCard.vue?vue&type=style&index=0&id=dc0cdc5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports